<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import DatatableLocalCharge from '@components/datatablegn/DatatableLocalcharge'
import { axiosGetPost } from '@router/axiosGetPost'
import AddLocalCharge from '@/src/components/localExpenses/AddLocalCharge'
import HarborManager from '@components/contract/harbor-manager'
import SurchargeManager from '@components/contract/surcharge-manager'
import CarrierManager from '@components/contract/carrier-manager'

export default {
  page: {
    title: 'Reviews Good / Fail',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatatableLocalCharge,
    AddLocalCharge,
    HarborManager,
    SurchargeManager,
    CarrierManager,
  },
  data() {
    return {
      request_id: this.$route.params.id,
      moduleT: 'FCL',
      title: 'Reviews Good / Fail',
      loadingGoods: false,
      loadingFails: false,
      loadedSurcharge: false,
      loadingBTab: false,
      isTesting: false,
      dataGoods: [],
      dataFails: [],
      items: [
        {
          text: 'Barracuda',
          href: '/',
        },
        {
          text: 'Localcharges FCL',
          href: '/accounts',
          active: true,
        },
        {
          text: 'Good - Fail',
          active: true,
        },
      ],
      modalComponent: null,
      modalTitle: 'Status',
      modalError: null,
      modalErrorShow: false,
      showModal: false,
      historyData: [],
      loadingData: false,
    }
  },
  computed: {},
  created() {
    this.request_id = this.$route.params.id
    this.fetchData()
  },
  mounted() {},
  methods: {
    fetchData() {
      this.loadingGoods = true
      this.loadingFails = true

      axiosGetPost(
        'get',
        'localCharges/datatables/' + this.request_id,
        {},
        'Load DataTable Localcharge Good&Fail'
      ).then((response) => {
        this.dataGoods = [response.good, response.columns]
        this.loadingGoods = false
        this.dataFails = [response.fail, response.columns]
        this.loadingFails = false
      })
    },

    downloadFileRequest(id) {
      axiosGetPost(
        'get',
        '/localCharges/downloadF/' + id,
        {},
        'Download File Operation Localcharge Import'
      ).then((response) => {
        console.log(response)
        if (response.success === true) {
          var link = document.createElement('a')
          link.setAttribute('target', '_blank')
          link.href = response.url
          link.click()
          URL.revokeObjectURL(link.href)
        } else {
          this.$toastr.e(
            'Error Download. Status code: ' +
              response.status +
              ' Error: ' +
              response.error
          )
        }
        return response
      })
    },
    addLocalcharge(dataRow) {
      console.log(dataRow)
      this.showModal = true
      this.loadingData = true
      this.modalComponent = 'AddLocalCharge'
      this.modalTitle = 'Add / Include LocalCharge'
      this.loadingData = false
    },
    addVariation(type = 'harbors') {
      this.showModal = true
      this.modalComponent =
        type == 'harbors' ? 'HarborManager' : 'SurchargeManager'
      this.modalTitle =
        'Add Variation ' + (type == 'harbors' ? 'Harbors' : 'Surcharges')
    },
    showCarrierManager() {
      this.showModal = true
      this.modalComponent = 'CarrierManager'
      this.modalTitle = 'Carriers Manager'
    },
    saveModal() {
      this.showModal = false
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="col-md-3">
                <h4 class="header-title mt-0 mb-1"
                  >Failure Review - Localcharges:
                  {{ moduleT + ' - ' + request_id }}</h4
                >
              </div>
              <div class="mb-md-2 col-md-8">
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Download File"
                  @click="downloadFileRequest(request_id)"
                  >Download File <i class="uil uil-cloud-download"></i> </button
                >&nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Add Localcharge"
                  @click="addLocalcharge('addLocalCharge')"
                  >Add Localcharge
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Harbor Manager"
                  @click="addVariation('harbors')"
                  >Harbor Manager
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Surcharges Manager"
                  @click="addVariation('chargers')"
                  >Surcharges Manager
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <button
                  class="btn btn-sm my-0 btn-outline-secondary"
                  title="Carriers Manager"
                  @click="showCarrierManager()"
                  >Carrier Manager
                  <i class="uil uil-plus"></i>
                </button>
                &nbsp;
                <router-link
                  class="btn btn-sm my-0 btn-outline-primary"
                  title="Add Localcharge"
                  href="#"
                  :to="{
                    name: 'account_detail_localcharge',
                    params: {
                      id: request_id,
                    },
                  }"
                  >Account Details
                  <i class="uil uil-up"></i>
                </router-link>
                &nbsp;
              </div>
            </div>
            <div class="row">
              <div class="mb-md-2 col-md-12">
                <b-tabs align="center">
                  <!-- Fail localcharge Tab **************************************************************  -->
                  <b-tab>
                    <template #title>
                      <i
                        class="uil uil-times-circle"
                        style="font-size: 13px; color: brown"
                      ></i>
                      &nbsp; <strong>Fail Localcharge</strong>
                    </template>
                    <div
                      v-if="loadingFails"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-down mt-2"
                        style="color: brown"
                      >
                        &nbsp; </span
                      ><strong
                        >Localcharges Failed: {{ dataFails[0].length }}</strong
                      >
                      <br />
                      <DatatableLocalCharge
                        :table-data="dataFails"
                        type-table="fail"
                        :request-id="request_id"
                        :inc-options="['editFails', 'delete']"
                        :variation-cell="['origin', 'destiny', 'surcharge']"
                        @closeModal="fetchData"
                      />
                    </div>
                  </b-tab>
                  <!-- Good Surcharge Tab **************************************************************  -->
                  <b-tab>
                    <template #title>
                      <i
                        class="uil uil-check-circle"
                        style="font-size: 13px; color: forestgreen"
                      ></i>
                      &nbsp;
                      <strong>Good Localcharge</strong>
                    </template>
                    <!-- <b-tab v-if="haveSurcharge" title=" Don't have Surcharge"> -->
                    <div
                      v-if="loadingGoods"
                      class="row align-items-center justify-content-center"
                      style="height: 300px"
                    >
                      <div class="col-12 col-md-8 text-center">
                        <b-spinner
                          label="Loading..."
                          variant="secondary"
                          class="ml-3"
                        ></b-spinner>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        class="uil uil-thumbs-up mt-2"
                        style="color: forestgreen"
                      >
                        &nbsp; </span
                      ><strong
                        >Good Localcharge: {{ dataGoods[0].length }}</strong
                      >
                      <DatatableLocalCharge
                        :table-data="dataGoods"
                        type-table="good"
                        :request-id="request_id"
                        :inc-options="['edit', 'delete']"
                        @closeModal="fetchData"
                      />
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-lg"
        ref="requestFcl"
        v-model="showModal"
        size="lg"
        :title="modalTitle"
        title-class="font-18"
      >
        <div
          v-if="loadingData"
          class="row align-items-center justify-content-center"
          style="height: 300px"
        >
          <div class="col-12 col-md-8 text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              class="ml-3"
            ></b-spinner>
          </div>
        </div>

        <div v-else-if="modalErrorShow === true">
          <div
            class="row align-items-center justify-content-center"
            style="height: 300px"
          >
            <div class="col-12 col-md-8 text-center">
              <feather type="frown" class="icon-xxl icon-dual-info"></feather>
              <h6 class="text-muted">{{ modalError }}</h6>
            </div>
          </div>
        </div>
        <AddLocalCharge v-if="modalComponent === 'AddLocalCharge'" />
        <HarborManager
          v-if="modalComponent === 'HarborManager' && loadingData === false"
        />
        <SurchargeManager
          v-if="modalComponent === 'SurchargeManager' && loadingData === false"
        />
        <CarrierManager
          v-if="modalComponent === 'CarrierManager' && loadingData === false"
        />
        <template v-slot:modal-footer>
          <b-button variant="light" @click="saveModal">Close</b-button>
          <b-button
            v-if="
              loadingData === false &&
                modalErrorShow === false &&
                modalComponent === ''
            "
            variant="primary"
            @click="saveModal"
          >
            OK
          </b-button>
        </template>
      </b-modal>
    </div>
  </Layout>
</template>
<style type="text/css">
.show .btn-success.dropdown-toggle {
  color: #010b55;
  background-color: #e9e9e9;
  border-color: #001add;
}

.text {
  font-family: helvetica;
  font-weight: bold;
  color: #71d90b;
}
</style>
